<template>
  <v-server-table
    :columns="columns"
    :options="options"
  />
</template>

<script>
import { getReactions } from '@/api'
import wait from '@/lib/wait'

export default {
  name: 'ReactionHistory',

  data () {
    return {
      columns: [
        'type',
        'reactable_type',
        'reactable_id',
        'content',
        'created_at'
      ],

      options: {
        filterable: ['type', 'reactable_type', 'reactable_id'],
        filterByColumn: true,
        listColumns: {
          type: [
            {
              id: 'like',
              text: 'Like'
            },
            {
              id: 'favorite',
              text: 'Favorite'
            },
            {
              id: 'bookmark',
              text: 'Bookmark'
            }
          ],
          reactable_type: [
            {
              id: 'App\\Dashboard',
              text: 'App\\Dashboard'
            },
            {
              id: 'App\\Agent',
              text: 'App\\Agent'
            },
            {
              id: 'App\\Listing',
              text: 'App\\Listing'
            },
            {
              id: 'App\\Guide',
              text: 'App\\Guide'
            }
          ]
        },
        sortable: ['type', 'reactable_type', 'created_at'],
        sortIcon: {
          base: 'fa',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
          is: 'fa-sort'
        },
        perPage: 10,
        perPageValues: [5, 10, 25, 50],
        headings: {
          type: 'Reaction Type',
          reactable_type: 'Model Type',
          reactable_id: 'Model ID',
          created_at: 'Created'
        },
        dateColumns: ['created_at'],

        requestFunction (data) {
          console.log('requestFunction', data)

          wait.loading()

          return getReactions({
            page: data.page,
            perPage: data.limit,
            orderBy: data.orderBy,
            dir: data.ascending ? 'asc' : 'desc',
            ...data.query
          }).then(response => {
            wait.loaded()

            return response.data
          }).catch(() => {
            wait.oops()
          })
        },
        responseAdapter (response) {
          return {
            data: response.data,
            count: response.total
          }
        }
      }
    }
  }
}
</script>
